import React from 'react'
import { BaseStyled, HighlightStyled } from './Common.styles'

export const HighlightStat: React.FC<{
  title: string
  value: unknown
  highlightOn: boolean
}> = ({ title, value, highlightOn, ...props }) => {
  const elm = (
    <>
      <strong>{title}</strong> {value}
    </>
  )

  if (!highlightOn) {
    return <BaseStyled {...props}>{elm}</BaseStyled>
  }

  return <HighlightStyled {...props}>{elm}</HighlightStyled>
}
